import { it, no } from 'vuetify/locale';

export default {
  welcome: 'Velkommen tilbage',
  accounts: 'Kontoer',
  account: 'Konto',
  dashboard: "Kontrollpanel",
  loading: 'Indlæser...',
  products: "Produkter",
  suppliers: "Leverandører",
  customers: "Kunder",
  users: "Brugere",
  product: "Produkt",
  productStatus: "Produktstatus",
  newProduct: "Nyt produkt",
  errorCreateProduct: "Fejl ved oprettelse af produkt, tjek venligst alle felter igen.",
  errorUpdateProduct: "Fejl ved opdatering af produkt, tjek venligst alle felter igen.",
  errorDeleteProduct: "Fejl ved sletting af produkt.",
  regulationsSuccess: "Regulering gennemført",
  regulationsError: "Regulering fejl, tjek venligst alle felter igen.",
  restock: "Genbestil",
  editProduct: "Rediger produkt",
  deleteProduct: "Slett produkt",
  productCreated: "Produkt oprettet",
  productUpdated: "Produkt opdateret",
  productDeleted: "Produkt slettet",
  regulationQuantity: "Reguler antal",
  addSubtract: "Tilføj / Fjern fra",
  newLocation: "Ny lokasjon",
  movementFrom: "Flytning fra",
  cancel: "Annuller",
  move: "Flyt",
  currentStock: "Aktuelt lager",
  stockRegulations: "Lagerreguleringer",
  quantityToMove: "Antal at flytte",
  editLocation: "Rediger lokasjon",
  deleteLocation: "Slett lokasjon",
  missingLocation: "Manglende lokasjon",
  newSupplier: "Ny leverandør",
  editSupplier: "Rediger leverandør",
  deleteSupplier: "Slett leverandør",
  newCustomer: "Ny kunde",
  editCustomer: "Rediger kunde",
  deleteCustomer: "Slett kunde",
  supplierCreated: "Leverandør oprettet",
  supplierUpdated: "Leverandør opdateret",
  supplierDeleted: "Leverandør slettet",
  customerCreated: "Kunde oprettet",
  customerUpdated: "Kunde opdateret",
  customerDeleted: "Kunde slettet",
  companyNumber: "CVR-nummer",
  companyName: "Firmanavn",
  address1: "Adresse 1",
  address2: "Adresse 2",
  city: "By",
  zipCode: "Postnummer",
  country: "Land",
  contactPhone: "Kontakt telefon",
  contactEmail: "Kontakt e-mail",
  contactPerson: "Kontakt person",
  supplier: "Leverandør",
  customer: "Kunde",
  purchases: "Køb",
  purchase: "Køb",
  sales: "Salg",
  sale: "Salg",
  user: "Bruger",
  about: "Om Capture IT",
  orders: "Ordre",
  inventory: "Lager",
  reports: "Rapporter",
  priceValue: "Lager værdi",
  stockValue: "Lager værdi",
  regulations: "Lagerreguleringer",
  stockMovements: "Lagerflytninger",
  checkingDrafts: "Lager optælling",
  locations: "Lokasjoner",
  location: 'Lokasjon',
  locationNumber: 'Lokasjonsnummer',
  defaultLocation: 'Standard lokasjon',
  supplier: 'Leverandør',
  number: 'Nummer',
  name: 'Navn',
  locationName: 'Lokasjonsnavn',
  mandatoryLocationName: '*Lokasjonsnavn',
  mandatoryDefaultLocation: '*Standard lokasjon',
  selectRemoveAll: 'Velg / Fjern alle',
  accountNumber: 'Kontonummer',
  fullname: 'Fullt navn',
  email: 'E-post',
  role: 'Rolle',
  actions: 'Handlinger',
  general: 'Generelt',
  other: 'Annet',
  image: 'Bilde',
  productImage: 'Produktbilde',
  barcode: 'Strekkode',
  quantity: 'Antal',
  labelQuantity: 'Antal etiketter',
  price: 'Pris',
  pricePerUnit: 'Pris per enhet',
  salesPrice: 'Salgspris',
  purchasePrice: 'Kostspris',
  total: 'Total',
  productName: 'Produktnavn',
  mandatoryProductName: '*Produktnavn',
  productNumber: 'Produktnummer',
  productNumberMandatory: '*Produktnummer',
  productGroup: 'Produktgruppe',
  stock: 'Lager',
  minStock: 'Minimum lager',
  status: 'Status',
  published: 'Åben',
  scheduled: 'Planlagt',
  inactive: 'Lukket',
  date: 'Dato',
  description: 'Beskrivelse',
  height: 'Høyde',
  width: 'Bredde',
  depth: 'Dybde',
  weight: 'Vekt',
  quantity: 'Antal',
  usersPerPageText: 'Brukere per side:',
  productsPerPageText: 'Produkter per side:',
  locationsPerPageText: 'Lokasjoner per side:',
  suppliersPerPageText: 'Leverandører per side:',
  customersPerPageText: 'Kunder per side:',
  purchasesPerPageText: 'Køb per side:',
  salesPerPageText: 'Salg per side:',
  ordersPerPageText: 'Ordre per side:',
  itemsPerPageText: 'Elementer per side:',
  of: 'av',
  to: 'til',
  on: 'på',
  quantity: 'Antal',
  one: 'en',
  note: 'bemærkning',
  pageText: '{0} - {1} av {2}',
  fullnameMandatory: 'Fullt navn er påkrevd',
  emailInvalid: 'Ugyldig e-post',
  userMandatory: 'Brukernavn og passord er påkrevd',
  emailMandatory: 'E-post er påkrevd',
  userCreated: 'Bruker opprettet!',
  errorCreateUser: 'Feil ved opprettelse av bruker, sjekk alle felt på nytt.',
  userdeleted: 'Brukeren er blitt slettet',
  errorDeleteUser: 'Feil ved sletting av bruker',
  appname: 'PicklyWMS',
  login: 'Logg inn',
  settings: 'Innstillinger',
  importExport: 'Import / Eksport',
  import: 'Importere',
  export: 'Eksportere',
  importProducts: 'Importere produkter',
  exportProducts: 'Eksportere produkter',
  uploadFile: 'Last opp fil',
  uploadFileText: 'Træk en Excel eller CSV-fil her.',
  uploadSucceded: 'Opplasting fullført',
  uploadFailed: 'Opplasting mislyktes',
  language: 'Språk',
  darkMode: 'Mørk modus',
  showProducts: 'Vis inaktive produkter',
  showLocations: 'Vis inaktive lokasjoner',
  other: 'Annet',
  update: 'Oppdater',
  selectLanguage: 'Velg språk',
  english: 'Engelsk',
  danish: 'Dansk',
  swedish: 'Svensk',
  norwegian: 'Norsk',
  finnish: 'Finsk',
  enabled: 'Aktiveret',
  disabled: 'Deaktiveret',
  required: 'Obligatorisk',
  optional: 'Valgfri',
  username: 'Brukernavn',
  password: 'Passord',
  print: 'Skriv ut',
  printSelected: 'Skriv ut valgte',
  close: 'Lukk',
  save: 'Lagre',
  cancel: 'Avbryt',
  reset: 'Tilbakestill',
  clear: 'Tøm',
  create: 'Opprett',
  edit: 'Rediger',
  delete: 'Slett',
  confirmDelete: 'Bekreft sletting',
  deleteWarningUser: 'Er du sikker på, at du vil slette denne brukeren?',
  deleteWarningProduct: 'Er du sikker på, at du vil slette dette produktet?',
  error: 'Feil',
  success: 'Suksess',
  info: 'Info',
  warning: 'Advarsel',
  submit: 'Send',
  search: 'Søk',
  newUser: 'Ny bruker',
  editUser: 'Rediger bruker',
  deleteUser: 'Slett bruker',
  oneRegistered: 'Det er registrert en',
  thereAreXRegistered: 'Det er registrert',
  weHaveOneRegistered: 'Vi har registrert en',
  weHaveXRegistered: 'Vi har registrert',
  warehouseManagement: 'Lagerstyring',
  trade: 'Handel',
  notYetImplemented: 'Ikke implementert ennå',
  notYetImplementedText: 'Denne funksjonen er ikke implementert ennå. Vennligst kontakt oss for mer informasjon.',
  goBack: 'Gå tilbake',
  categories: 'Kategorier',
  category: 'Kategori',
  newCategory: 'Ny kategori',
  editCategory: 'Rediger kategori',
  deleteCategory: 'Slett kategori',
  categoryCreated: 'Kategori opprettet',
  categoryUpdated: 'Kategori oppdatert',
  categoryDeleted: 'Kategori slettet',
  errorCreateCategory: 'Feil ved opprettelse av kategori, sjekk alle felt på nytt.',
  errorUpdateCategory: 'Feil ved oppdatering av kategori, sjekk alle felt på nytt.',
  errorDeleteCategory: 'Feil ved sletting av kategori.',
  mandatoryCategoryName: '*Kategorinavn',
  categoryName: 'Kategorinavn',
  categoryDescription: 'Kategoribeskrivelse',
  categoriesPerPageText: 'Kategorier per side:',
  usePrintServer: "Bruk Print Server (Silent Printing)",
  printJobSent: "Utskriftsjobb sendt til server.",
  printJobsSent: "Alle utskriftsjobber sendt til server.",
  printJobFailed: "Utskriftsjobb mislyktes",
  printServerConnectionError: "Kunne ikke koble til print server. Kjører den?",
  printBatchFailed: "Utskriftsbatch mislyktes. Minst én jobb kunne ikke sendes.",
  noLabelSelectedError: "Ingen etikettmal valgt.",
  onlyInStock: "Kun produkter på lager",
  valueFromCostPrice: "Verdi basert på kostpris"
};